import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=390b4b49&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=ts&"
export * from "./Classroom.vue?vue&type=script&lang=ts&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=390b4b49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b4b49",
  null
  
)

export default component.exports